/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuthTransferInRequest = {
  /**
   * Start mode: the platform host that holds the session to move here (e.g. app.getgram.ai)
   */
  sourceHost?: string | undefined;
  /**
   * Callback mode: the opaque one-time transfer code from the source host's transferOut endpoint
   */
  code?: string | undefined;
  /**
   * Optional URL path to land on once the session is established on this host
   */
  redirect?: string | undefined;
};

export type AuthTransferInResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type AuthTransferInRequest$Outbound = {
  source_host?: string | undefined;
  code?: string | undefined;
  redirect?: string | undefined;
};

/** @internal */
export const AuthTransferInRequest$outboundSchema: z.ZodMiniType<
  AuthTransferInRequest$Outbound,
  AuthTransferInRequest
> = z.pipe(
  z.object({
    sourceHost: z.optional(z.string()),
    code: z.optional(z.string()),
    redirect: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceHost: "source_host",
    });
  }),
);

export function authTransferInRequestToJSON(
  authTransferInRequest: AuthTransferInRequest,
): string {
  return JSON.stringify(
    AuthTransferInRequest$outboundSchema.parse(authTransferInRequest),
  );
}

/** @internal */
export const AuthTransferInResponse$inboundSchema: z.ZodMiniType<
  AuthTransferInResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function authTransferInResponseFromJSON(
  jsonString: string,
): SafeParseResult<AuthTransferInResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthTransferInResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthTransferInResponse' from JSON`,
  );
}
